"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Checkbox_component_exports = {};
__export(Checkbox_component_exports, {
  Checkbox: () => Checkbox
});
module.exports = __toCommonJS(Checkbox_component_exports);
var import_react = __toESM(require("react"));
var import_Checkbox = require("./Checkbox.styled");
var _excluded = ["isDisabled", "isChecked", "indeterminate", "checkboxSize", "tabIndex", "darkMode", "transparentBackground"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Size = /* @__PURE__ */ function(Size2) {
  Size2["small"] = "small";
  Size2["medium"] = "medium";
  return Size2;
}(Size || {});
var Checkbox = function Checkbox2(_ref) {
  var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isChecked = _ref.isChecked, isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked, _ref$indeterminate = _ref.indeterminate, indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate, _ref$checkboxSize = _ref.checkboxSize, checkboxSize = _ref$checkboxSize === void 0 ? "medium" : _ref$checkboxSize, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$transparentBackg = _ref.transparentBackground, transparentBackground = _ref$transparentBackg === void 0 ? false : _ref$transparentBackg, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(isChecked), _useState2 = _slicedToArray(_useState, 2), inputChecked = _useState2[0], setInputChecked = _useState2[1];
  var _useState3 = (0, import_react.useState)(indeterminate), _useState4 = _slicedToArray(_useState3, 2), inputIndeterminate = _useState4[0], setInputIndeterminate = _useState4[1];
  (0, import_react.useEffect)(function() {
    setInputIndeterminate(indeterminate);
  }, [indeterminate]);
  (0, import_react.useEffect)(function() {
    setInputChecked(isChecked);
  }, [isChecked]);
  var handleChange = function handleChange2(event) {
    if (!props["aria-disabled"]) {
      setInputChecked(!inputChecked);
      if (inputIndeterminate) {
        setInputIndeterminate(false);
        setInputChecked(false);
      }
      if (props.onChange) {
        props.onChange(event, props.id);
      }
    }
  };
  var onKeyUpEvent = function onKeyUpEvent2(e) {
    if (e.key === "Enter" && props.onKeyUp)
      handleChange(e);
  };
  return /* @__PURE__ */ import_react.default.createElement(import_Checkbox.StyledCheckboxContainer, {
    className: props.className,
    checkboxSize
  }, /* @__PURE__ */ import_react.default.createElement(import_Checkbox.StyledLabel, {
    withDisabledStyles: !!props["aria-disabled"],
    disabled: isDisabled,
    darkMode,
    htmlFor: props.id,
    checkboxSize
  }, /* @__PURE__ */ import_react.default.createElement(import_Checkbox.StyledCheckbox, {
    withDisabledStyles: !!props["aria-disabled"],
    checkboxSize,
    "aria-label": props["aria-label"] || props.label,
    id: props.id,
    type: "checkbox",
    className: "checkbox",
    name: props.name,
    checked: inputChecked,
    disabled: isDisabled,
    onChange: handleChange,
    onKeyUp: onKeyUpEvent,
    tabIndex,
    darkMode,
    transparentBackground,
    ref: function ref(input) {
      if (input) {
        var checkboxInput = input;
        checkboxInput.indeterminate = inputIndeterminate;
      }
    },
    "data-dp-analytics-id": props.dataDpAnalyticsId,
    "aria-disabled": props["aria-disabled"],
    "data-testid": "checkbox-test"
  }), /* @__PURE__ */ import_react.default.createElement(import_Checkbox.StyledCheckMark, {
    "aria-hidden": true,
    "data-testid": "checkmark-test",
    checkboxSize,
    darkMode
  }), props.label && /* @__PURE__ */ import_react.default.createElement(import_Checkbox.StyledLabelTextWrapper, null, props.label)));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Checkbox
});
//# sourceMappingURL=Checkbox.component.js.map